export default __webpack_public_path__ + "static/media/PAS.63ac3d1d.jpg";